import {
	BrowserRouter as Router,
	Routes,
	Route,
} from 'react-router-dom';

import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
// import Banner from './components/Banner.jsx';

import HomePage from './pages/HomePage.jsx';
import AboutUsPage from './pages/AboutUsPage.jsx';
import ContactUsPage from './pages/ContactUsPage.jsx';
import PageNotFoundPage from './pages/PageNotFoundPage.jsx';
import EventsPage from './pages/EventsPage.jsx';
import MembersPage from './pages/MembersPage.jsx';
// import GalleryPage from './pages/GalleryPage.jsx';

function App() {
	return (
		<div className="app">
			<Router className="app">
				<Header />

				<Routes>
					<Route exact path="/" element={<HomePage />} />
					<Route
						path="/about-us"
						element={<AboutUsPage />}
					/>
					<Route
						path="/contact-us"
						element={<ContactUsPage />}
					/>
					<Route
						path="/events"
						element={<EventsPage />}
					/>
					<Route
						path="/members"
						element={<MembersPage />}
					/>
					{/* <Route
						path="/gallery"
						element={<GalleryPage />}
					/> */}
					<Route
						path="*"
						element={<PageNotFoundPage />}
					/>
				</Routes>
			</Router>

			<Router>
				<Footer />
			</Router>
		</div>
	);
}

export default App;
